import { Popover } from '@mui/material';
import React, { useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { updateTreeMapStyleOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import SliderWithInput from '../SliderWithInput';
import SwitchWithInput from '../SwitchWithInput';
import { RootState } from '../../../redux';

const TreeMapLegend = ({ iconColor }: { iconColor?: string }) => {
  const dispatch = useDispatch();

  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  var propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  const handleUpdate = (option: string, value: any) => {
    dispatch(updateTreeMapStyleOptions(propKey, option, value));
  };

  const treeLegend = chartControls.properties[propKey].treeMapChartControls;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const itemWidthMinMax: any = { min: 25, max: 50, step: 1 };
  const itemHeightMinMax: any = { min: 25, max: 50, step: 1 };

  return (
    <div className="optionsInfo">
      <div
        className="optionDescription"
        style={{ paddingBottom: '5px', paddingLeft: '2px', marginTop: '5px' }}
      >
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{
            marginRight: '15px',
            color: iconColor ? iconColor : '#404040',
          }}
        >
          Show Breadcrumb
        </label>
      </div>
      <div style={{ marginLeft: '-30px' }}>
        <SwitchWithInput
          isChecked={treeLegend.showBreadCrumb}
          onSwitch={() => handleUpdate('showBreadCrumb', !treeLegend.showBreadCrumb)}
        />
      </div>
      {treeLegend.showBreadCrumb ? (
        <React.Fragment>
          <div
            className="optionDescription"
            style={{
              marginTop: '0',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Width
          </div>
          <SliderWithInput
            sliderValue={treeLegend.bcWidth}
            sliderMinMax={itemWidthMinMax}
            percent={true}
            changeValue={(value: any) => handleUpdate('bcWidth', value)}
          />
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            Height
          </div>
          <SliderWithInput
            sliderValue={treeLegend.bcHeight}
            sliderMinMax={itemHeightMinMax}
            percent={true}
            changeValue={(value: any) => handleUpdate('bcHeight', value)}
          />

          <div className="optionDescription">
            <div></div>
            <label
              htmlFor="enableDisable"
              className="enableDisableLabel"
              style={{
                transform: 'TranslateX(-5px)',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              Breadcrumb Color
            </label>
          </div>
          <div
            style={{
              height: '1.25rem',
              width: '25%',
              marginLeft: '12px',
              backgroundColor: treeLegend.bcColor,
              color: treeLegend.bcColor,
              border: '2px solid darkgray',
              marginRight: 'auto',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            {'  '}
          </div>
        </React.Fragment>
      ) : null}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div>
          <SketchPicker
            color={treeLegend.bcColor}
            className="sketchPicker"
            width="16rem"
            onChangeComplete={(color: ColorResult) => handleUpdate('bcColor', color.hex)}
            onChange={(color: ColorResult) => handleUpdate('bcColor', color.hex)}
            disableAlpha
          />
        </div>
      </Popover>
    </div>
  );
};

export default TreeMapLegend;
